import { render } from "./ProductButtons.vue?vue&type=template&id=a2aa5076&scoped=true&ts=true"
import script from "./ProductButtons.vue?vue&type=script&lang=ts"
export * from "./ProductButtons.vue?vue&type=script&lang=ts"

import "./ProductButtons.vue?vue&type=style&index=0&id=a2aa5076&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2aa5076"]])

export default __exports__